import { Sheet as CssModulesSheet } from '@sunwebgroup/uds-ui/sheet'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/sheet' instead.
 */
const SheetWrapper = {
  Root: CssModulesSheet.Root,
  Trigger: CssModulesSheet.Trigger,
  Body: styled(CssModulesSheet.Body)``,
  Content: styled(CssModulesSheet.Content)``,
  Footer: styled(CssModulesSheet.Footer)``,
  Header: styled(CssModulesSheet.Header)``,
  Close: CssModulesSheet.Close,
}

export default SheetWrapper
